export const PROFILE_UPDATE_USER_SUCCESS = "profile/PROFILE_UPDATE_USER";
export const PROFILE_UPDATE_USER_FAILURE = "profile/PROFILE_UPDATE_USER_FAILURE";
export const PROFILE_GET_USER_SUCCESS = "profile/ PROFILE_GET_USER_SUCCESS";
export const PROFILE_GET_USER_FAILURE = "profile/PROFILE_GET_USER_FAILURE";
export const COMPANY_INFO_SUCCESS = "profile/ COMPANY_INFO_SUCCESS";
export const COMPANY_INFO_FAILURE = "profile/COMPANY_INFO_FAILURE";
